import axios from 'axios'

const $axios = axios.create({
    baseURL: '/wp-json/ansolution'
})

export default () => {
    $axios.interceptors.request.use(request => {
        request.headers.common['Content-Type'] = 'application/json'
        return request
    })
    return $axios
}
